module.exports = __webpack_public_path__ + "img/placeholder.4400efa9.jpg";